import { apiFetch, apiUrl, isSuccess } from "./apiClient";

export async function getAnnouncements() {
  try {
    const response = await apiFetch(apiUrl("/notifications/getAnnouncements"));
    if (isSuccess(response)) {
      return response.json();
    }
    // Return empty array for any error status
    console.error(`Failed to fetch announcements: ${response.status}`);
    return [];
  } catch (error) {
    // Handle network errors or fetch failures
    console.error("Failed to fetch announcements:", error);
    return [];
  }
}

export async function getOutageAlerts() {
  try {
    const response = await apiFetch(apiUrl("/notifications/getOutageAlerts"));
    if (isSuccess(response)) {
      return response.json();
    }
    // Return empty array for any error status
    console.error(`Failed to fetch outage alerts: ${response.status}`);
    return [];
  } catch (error) {
    // Handle network errors or fetch failures
    console.error("Failed to fetch outage alerts:", error);
    return [];
  }
}

export async function readAnnouncements(announcementsList) {
  const response = await apiFetch(apiUrl("/notifications/readAnnouncements"), {
    option: "POST",
    body: announcementsList,
  });
  if (isSuccess(response)) {
    return response.json();
  }
  throw new Error(`Error reading announcements`);
}
